import { useQuery } from '@tanstack/react-query';
import React, { memo } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ChainedSegmentSelect, FilterGroup, FilterLabel } from '../../../../../../../components';
import { mapDispatchToProps, mapStateToProps } from '../../../../../../../reducers/ipa/limits/filters/segment';
import { listSegmentTypeDataQuery } from '../../pages/RegisterLimitPage/service';

type StoreFilterProps = RouteComponentProps & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const StoreFilter = memo(
  ({ selectType, data: { value }, resetSegmentValueByKey, setSegmentValueByKey, resetSelectType, handleSelectSelectType }: StoreFilterProps) => {
    const { data: segmentTypeData = [] } = useQuery(listSegmentTypeDataQuery());

    return (
      <FilterGroup asChild>
        <li>
          <FilterLabel>Segmentação</FilterLabel>
          <ChainedSegmentSelect
            select={{
              data: segmentTypeData,
              value: selectType ?? undefined,
              onSelect: handleSelectSelectType,
              onClean: resetSelectType,
            }}
            check={{
              value: value?.[selectType as keyof typeof value] ?? [],
              onSelect: setSegmentValueByKey,
              onClean: resetSegmentValueByKey,
            }}
          />
        </li>
      </FilterGroup>
    );
  },
);

StoreFilter.displayName = 'StoreFilter';

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StoreFilter));
